import React from 'react';

const Navbar = () => {
  return (
    <nav>
      <p>LAUNCHPAD</p>
    </nav>
  );
};

export default Navbar;
